module.exports = " <div class=\"bar bar-header item-input-inset\"> <label class=item-input-wrapper> <i class=\"icon ion-ios-search placeholder-icon\"></i> <form action=\"\" id={{formId}}> <input type=search placeholder={{placeholder}} v-model=value> </form> </label> <button class=\"button button-clear button-positive\" @click=cancel()> {{cancelText}} </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/input/Search.vue
// module id = 233
// module chunks = 0